import VueI18n from "vue-i18n";

class AppI18n extends VueI18n {
  /**
   * @param {I18nOptions} options
   */
  constructor(options) {
    super(options);

    window.document.querySelector("html").setAttribute("lang", this.locale);

    /**
     * @private
     * @type {Set<Locale>}
     */
    this._loadedLocales = new Set([this.locale ?? this.fallbackLocale]);
  }

  /**
   * @returns {Locale[]}
   */
  get loadedLocales() {
    return [...this._loadedLocales];
  }

  /**
   * @returns {Locale}
   */
  get locale() {
    return super.locale;
  }

  /**
   * @param {Locale} locale
   */
  set locale(locale) {
    this.setLocale(locale);
  }

  /**
   * @public
   * @param {Locale} locale
   * @returns {Promise<void>}
   */
  async setLocale(locale) {
    if (this.locale === locale) return;

    if (!this._loadedLocales.has(locale)) {
      await this.loadLocaleMessages(locale);
    }

    super.locale = locale;

    window.document.querySelector("html").setAttribute("lang", locale);
  }

  /**
   * @private
   * @param {Locale} lang
   * @returns {Promise<void>}
   */
  async loadLocaleMessages(lang) {
    const messages = await import(`@/locales/entries/${lang}.js`);

    this.setLocaleMessage(lang, messages.__esModule ? messages.default : messages);
    this._loadedLocales.add(lang);
  }
}

export { AppI18n };
